var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpandAll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 18,
    viewBox: "0 0 6 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.07516 3.575L2.41683 2.23333V6.66667C2.41683 7.01667 2.65016 7.25 3.00016 7.25C3.35016 7.25 3.58349 7.01667 3.58349 6.66667V2.23333L4.92516 3.575C5.04183 3.69167 5.21683 3.75 5.33349 3.75C5.45016 3.75 5.62516 3.69167 5.74183 3.575C5.97516 3.34167 5.97516 2.99167 5.74183 2.75833L3.40849 0.425C3.17516 0.191667 2.82516 0.191667 2.59183 0.425L0.258496 2.75833C0.0251628 2.99167 0.0251628 3.34167 0.258496 3.575C0.491829 3.80833 0.841829 3.80833 1.07516 3.575ZM4.92516 14.425L3.58349 15.7667V11.3333C3.58349 10.9833 3.35016 10.75 3.00016 10.75C2.65016 10.75 2.41683 10.9833 2.41683 11.3333V15.7667L1.07516 14.425C0.841829 14.1917 0.491829 14.1917 0.258496 14.425C0.0251628 14.6583 0.0251628 15.0083 0.258496 15.2417L2.59183 17.575C2.7085 17.6917 2.8835 17.75 3.00016 17.75C3.11683 17.75 3.29183 17.6917 3.40849 17.575L5.74183 15.2417C5.97516 15.0083 5.97516 14.6583 5.74183 14.425C5.50849 14.1917 5.15849 14.1917 4.92516 14.425Z",
    fill: "#00A3E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandAll);
export default __webpack_public_path__ + "static/media/expand-all.00732434c0d259e45567a94b61af682c.svg";
export { ForwardRef as ReactComponent };